const galleryImages = [
  {
    src: "https://public.readdy.ai/ai/img_res/0752e124576107f5ecb89ea80a58cc5e.jpg",
    caption: "@bluemoonbeautyoman",
  },
  {
    src: "https://readdy.ai/api/search-image?query=close%20up%20stunning%20nail%20art%20design%20gold%20and%20nude%20nails%2C%20luxury%20manicure%20result%2C%20beauty%20salon%20nails%20photography%20muscat&width=500&height=500&seq=bm_gram002&orientation=squarish",
    caption: "@bluemoonbeautyoman",
  },
  {
    src: "https://readdy.ai/api/search-image?query=gorgeous%20dark%20balayage%20hair%20transformation%20result%2C%20shiny%20glossy%20hair%2C%20salon%20photography%20lifestyle%20middle%20eastern%20woman&width=500&height=500&seq=bm_gram003&orientation=squarish",
    caption: "@bluemoonbeautyoman",
  },
  {
    src: "https://readdy.ai/api/search-image?query=beautiful%20glowing%20skin%20after%20luxury%20gold%20facial%20treatment%20oman%2C%20radiant%20skin%20close%20up%2C%20beauty%20spa%20result%20photography&width=500&height=500&seq=bm_gram004&orientation=squarish",
    caption: "@bluemoonbeautyoman",
  },
  {
    src: "https://readdy.ai/api/search-image?query=woman%20with%20stunning%20hair%20blowout%20transformation%20result%2C%20salon%20lifestyle%20photography%20warm%20gold%20tones%2C%20happy%20client%20muscat&width=500&height=500&seq=bm_gram005&orientation=squarish",
    caption: "@bluemoonbeautyoman",
  },
  {
    src: "https://readdy.ai/api/search-image?query=luxury%20beauty%20salon%20interior%20elegant%20gold%20and%20navy%20blue%20decor%20in%20oman%2C%20modern%20reception%20mirrors%20styling%20chairs%2C%20premium%20ambiance%20al%20koudh%20muscat&width=500&height=500&seq=bm_gram006&orientation=squarish",
    caption: "@bluemoonbeautyoman",
  },
];

export default function InstagramSection() {
  return (
    <section id="gallery" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            @bluemoonbeautyoman
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Beauty{" "}
            <span className="italic text-[#c6a864]">Gallery</span>
          </h2>
          <p
            className="text-[#1a2744] text-2xl font-bold mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            معرض أعمالنا الجمالية
          </p>
          <p
            className="text-[#1a2744]/60 text-sm mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            إبداعات صالون القمر الأزرق في الخوض، مسقط، سلطنة عمان
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="relative overflow-hidden h-[120px] sm:h-[180px] group cursor-pointer"
            >
              <img
                src={img.src}
                alt={`Blue Moon Beauty Salon Muscat Al Koudh Oman - Gallery ${i + 1}`}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#1a2744]/0 group-hover:bg-[#1a2744]/50 transition-colors duration-300 flex items-center justify-center">
                <i className="ri-instagram-line text-white text-2xl sm:text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://instagram.com/bluemoonbeautyoman"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer text-[#1a2744] text-xs tracking-[0.2em] uppercase border-b border-[#1a2744] pb-0.5 hover:text-[#c6a864] hover:border-[#c6a864] transition-colors duration-300"
          >
            <i className="ri-instagram-line text-base"></i>
            Follow @bluemoonbeautyoman
          </a>
          <span className="text-gray-300 hidden sm:inline">|</span>
          <a
            href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer text-[#25D366] text-xs tracking-wide hover:text-[#20ba5a] transition-colors duration-300"
            style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
          >
            <i className="ri-whatsapp-line text-base"></i>
            شاركينا إطلالتك — تواصلي معنا عبر واتساب
          </a>
        </div>
      </div>
    </section>
  );
}
